/*!
 * Copyright © 2020-2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { NgModule } from '@angular/core';
import { ErrorStateMatcher } from '@angular/material/core';
import { RouterModule } from '@angular/router';

import { environment } from '../../../../environments/environment';
import { CACHE_NONCE } from '../../../core/config/cache-nonce.token';
import { SharedModule } from '../../../shared/shared.module';
import { NotPristineAndDirtyErrorStateMatcher } from '../../../shared/validators';
import { EmailAddressComponent } from '../../components/email-address/email-address.component';
import { PasswordComponent } from '../../components/password/password.component';
import { SetYourPasswordComponent } from './set-your-password.component';

@NgModule({
  declarations: [SetYourPasswordComponent, PasswordComponent, EmailAddressComponent],
  imports: [
    RouterModule.forChild([
      {
        path: '',
        pathMatch: 'full',
        component: SetYourPasswordComponent
      }
    ]),
    SharedModule
  ],
  providers: [
    { provide: ErrorStateMatcher, useClass: NotPristineAndDirtyErrorStateMatcher },
    { provide: CACHE_NONCE, useValue: environment.config.cacheNonce }
  ],
  exports: [SetYourPasswordComponent]
})
export class SetYourPasswordModule {}
